import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/global.css';  // 全局样式
import App from './App.vue';
import router from './router';
import axios from 'axios';

Vue.use(ElementUI, { size: 'small' });

// 开发环境：走 vue.config.js 代理（/api -> localhost:3000）
// 生产环境：直接调用后端 product.wxkcgb.top（后端已配 CORS 允许跨域）
const isProd = process.env.NODE_ENV === 'production';
const API_BASE = isProd
  ? 'https://product.wxkcgb.top/api'  // 生产：直接调后端域名
  : '/api'; // 开发：本地代理

const http = axios.create({ baseURL: API_BASE });
Vue.prototype.$http = http;
Vue.config.productionTip = false;

// 请求拦截：自动带 token
http.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers['Authorization'] = 'Bearer ' + token;
  return config;
});

// 响应拦截：统一错误处理
http.interceptors.response.use(
  res => res.data,  // 直接返回 data 部分
  err => {
    const { response, message: netMsg } = err;
    // 网络错误
    if (!response) {
      Vue.prototype.$message.error('网络连接失败，请检查网络');
      return Promise.reject(err);
    }
    // 401：未登录（排除登录页本身的 401）
    if (response.status === 401 && router.currentRoute.path !== '/login') {
      localStorage.clear();
      Vue.prototype.$message.error('登录已过期，请重新登录');
      router.push('/login');
      return Promise.reject(err);
    }
    // 其他业务错误：从响应体取 message，没有则给默认提示
    const msg = (response.data && response.data.message) || '操作失败，请稍后重试';
    // 不在登录页时弹提示（登录页自己处理错误）
    if (router.currentRoute.path !== '/login') {
      Vue.prototype.$message.error(msg);
    }
    return Promise.reject(err);
  }
);

new Vue({ router, render: h => h(App) }).$mount('#app');
